export default __webpack_public_path__ + "static/media/InactiveSideArrow.14d6a388.svg";